import React, { useEffect } from 'react';
var DocumentTitle = function (_a) {
    var title = _a.title, children = _a.children;
    useEffect(function () {
        document.title = title ? "".concat(title, " | Login | Ally") : 'Login | Ally';
        return function () {
            document.title = 'Ally';
        };
    }, [title]);
    return React.createElement(React.Fragment, null, children);
};
export { DocumentTitle };
//# sourceMappingURL=DocumentTitle.js.map